import { render, staticRenderFns } from "./AreaCascader.vue?vue&type=template&id=1fc166f1"
import script from "./AreaCascader.vue?vue&type=script&lang=js"
export * from "./AreaCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports